import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import ServiceDetails from './components/ServiceDetails';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Privacy from './components/Privacy';

export default function Home() {
  return (
    <div className="min-h-screen bg-white font-['Noto_Sans_JP']">
      <Hero />
      <About />
      <Services />
      <ServiceDetails />
      <Pricing />
      <Contact />
      <Privacy />
    </div>
  );
}
